import React, { useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Person, Rank, Sex } from '../types/form';
import './App.css';
import FooterContent from './FooterContent';
import FormEmail from './FormEmail';
import FormPerson from './FormPerson';
import FormPhone from './FormPhone';
import FormPosition from './FormPosition';
import FormRank from './FormRank';

function App() {
  const [rank, setRank] = useState<Rank>({ instructor: null, scout: null });
  const [person, setPerson] = useState<Person>({ firstName: null, lastName: null, sex: Sex.MALE });
  const [position, setPosition] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const [phone, setPhone] = useState<string | null>(null);

  return (
    <Container className="App py-3">
      <Row>
        <Col>
          <Card className="App-card mb-4 rounded-3 shadow-sm">
            <Card.Header className="py-3 text-center">
              <h4 className="my-0">Generator stopek mailowych ZHP Chorągwi Krakowskiej</h4>
            </Card.Header>
            <Card.Body>
              <FormPerson {...{ person, setPerson }} />
              <FormRank {...{ person, rank, setRank }} />
              <FormPosition {...{ person, position, setPosition }} />
              <FormEmail {...{ email, emailValid, person, setEmail, setEmailValid }} />
              <FormPhone {...{ phone, setPhone }} />
              <FooterContent {...{ email, emailValid, person, phone, position, rank }} />
            </Card.Body>
          </Card>
          <div className="App-footer">
            &copy; 2024 Zespół ds. Wsparcia Technicznego{' '}
            <a href="https://krakowska.zhp.pl" target="_blank" rel="noreferrer">ZHP Chorągwi Krakowskiej</a>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default App;
